import Client from 'config/axios';

export const getAgentById = async (token: string, agentId: number) => {
  try {
    const { data } = await Client.get(`agent/${agentId}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return { data: data.data };
  } catch (response) {
    const result = response as any;
    return { errors: result.data };
  }
};
